<template>
    <div class="warning" :class="{ 'orange': orange, 'red': red, 'coral': coral }">
        <div class="warning-icon">
            <ion-icon v-if="coral" :src="alertCircle" size="large"></ion-icon>
            <ion-icon v-else :src="warningOutline" size="large"></ion-icon>
        </div>
        <div class="warning-content">
            <b v-if="title">{{ title }}</b>
            {{ body }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { IonIcon } from '@ionic/vue';
import { warningOutline, alertCircle } from "ionicons/icons";

defineProps<{
    title?: string,
    body?: string,
    orange?: boolean,
    red?: boolean,
    coral?: boolean,
}>()
</script>

<style scoped>
.warning {
    overflow: hidden;
    width: 100%;
    padding: 12px;
    border-left: 8px solid;
    background-color: #ededed;
    color: #a1a1a1;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
    box-shadow: 2px 2px 2px hwb(0deg 80% 20% / 33%);
}

.warning-content {
    width: 100%;
    line-height: 1.5;
    hyphens: auto;
}

.orange {
    border-color: #ffa502;
    background-color: #FCFC94;
    /* color: #ce8500; */
    color: hwb(39 0% 10% / 1);
}

.red {
    border-color: #d50013;
    background-color: #FFE0E3;
    color: hwb(0 20% 20% / 1);
}

.coral {
    border-color: var(--ion-color-coral-shade);
    background-color: var(--ion-color-coral);
    color: white;
}

.coral .warning-content {
    line-height: unset;
}
</style>

